import React from 'react';
import { Icon } from '@fluentui/react';

interface PageHeaderProps {
  title: string;
  iconName: string;
  loading?: boolean;
  className?: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  iconName,
  loading = false,
  className = '',
  actions,
}) => (
  <>
    <div
      className={className}
      style={{
          background: '#ffffff',
          borderRadius: '8px',
          marginBottom: '20px',
          position: 'relative',
          overflow: 'hidden',
        }}
    >
      {/* Loading overlay with subtle animation */}
      {loading && (
      <div
        style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.05) 50%, transparent 100%)',
              animation: 'shimmer 2s infinite',
              zIndex: 1,
            }}
      />
        )}

      <div style={{ position: 'relative', zIndex: 2 }}>
        <div
          style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
            }}
        >
          <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                minWidth: 0,
              }}
          >
            <div
              style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '8px',
                  background: loading ? '#f3f2f1' : '#f3f2f1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  flexShrink: 0,
                }}
            >
              {iconName === 'Billit' ? (
                <img src='/billit.png' alt='Billit' style={{ width: '28px', height: '28px' }} />
              ) : (
                <Icon
                  iconName={iconName}
                  style={{
                    fontSize: '18px',
                    color: loading ? '#71BF43' : '#605e5c',
                    animation: loading ? 'pulse 1.5s infinite' : 'none',
                  }}
                />
              )}
            </div>

            <h2
              style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  margin: 0,
                  color: '#323130',
                  fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
                }}
            >
              {title}
            </h2>
          </div>

          {actions ? (
            <div style={{ flexShrink: 0 }}>
              {actions}
            </div>
          ) : null}
        </div>
      </div>
    </div>

    <style>
      {`
          @keyframes shimmer {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.7; }
          }
        `}
    </style>
  </>
);

export default PageHeader;
